import AbstractController from '../../../Controller/AbstractController';
import Controller from '../../../Controller/Controller';
import Scarcity from '../Elements/Scarcity';

/**
 * Scarcity Controller
 *
 * @class
 */
class ScarcityController extends AbstractController {
	/**
	 * @constructor
	 */
	constructor() {
		super();

		Controller.registerController(this);
		this._registerElements(...Scarcity);
	}
}

export default new ScarcityController();
